module.exports = __webpack_public_path__ + "img/cta-1.b45308ae.jpg";